<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5.6 9.6H13.6L10.84 6L9 8.4L7.76 6.8L5.6 9.6ZM4.8 12.8C4.36 12.8 3.98333 12.6433 3.67 12.33C3.35667 12.0167 3.2 11.64 3.2 11.2V1.6C3.2 1.16 3.35667 0.783333 3.67 0.47C3.98333 0.156667 4.36 0 4.8 0H14.4C14.84 0 15.2167 0.156667 15.53 0.47C15.8433 0.783333 16 1.16 16 1.6V11.2C16 11.64 15.8433 12.0167 15.53 12.33C15.2167 12.6433 14.84 12.8 14.4 12.8H4.8ZM4.8 11.2H14.4V1.6H4.8V11.2ZM1.6 16C1.16 16 0.783333 15.8433 0.47 15.53C0.156667 15.2167 0 14.84 0 14.4V3.2H1.6V14.4H12.8V16H1.6Z"
      fill="#666666" />
  </svg>
</template>

<script setup>

</script>
